import { action } from 'satcheljs';

/**
 * Makes a service call to the MRU attachment service.
 * By default we get cloudy attachments, but if mc-replyWithMRUClassic is enabled then we get
 * both classic and cloudy attachments.
 */
export default action('getMRUSuggestionsAction');
